// extracted by mini-css-extract-plugin
export default {"area_wrapper":"area_wrapper___S6j0H","opened":"opened___SVyyi","area":"area___gPkwI","back_btn":"back_btn___altDR"};